import { Icon } from '@iconify/react';
import { useState } from 'react';
import searchFill from '@iconify/icons-eva/search-fill';
// material
import { styled, alpha } from '@mui/material/styles';
import { Box, Input, Slide, Button, InputAdornment, ClickAwayListener } from '@mui/material';
// components
import { MIconButton } from '../../components/@material-extend';
import studentmanagementService from 'services/studentmanagement.service';
import { PATH_DASHBOARD } from 'routes/paths';
import { Link, Link as RouterLink, useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const SearchbarStyle = styled('div')(({ theme }) => ({
  top: 0,
  left: 0,
  zIndex: 99,
  width: '100%',
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  height: APPBAR_MOBILE,
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  padding: theme.spacing(0, 3),
  boxShadow: theme.customShadows.z8,
  backgroundColor: `${alpha(theme.palette.background.default, 0.72)}`,
  [theme.breakpoints.up('md')]: {
    height: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

// ----------------------------------------------------------------------

export default function Searchbar() {
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [value, setValue] = useState('')
  const [typingTimeout, setTypingTimeout] = useState(0);
  const [result, setResult] = useState([null, null]);
  const handleChange = (searchValue) => {
    setValue(searchValue);
    if(typingTimeout){
      clearTimeout(typingTimeout)
    }
    setTypingTimeout(setTimeout(function () {
      studentmanagementService.get_student_quick(searchValue).then((data) => {
        if(data.data.status == 'fail'){
          setResult([null,null]);
        } else {
          setResult([data.data.name, data.data.id]);
        }
      });
    }, 200))
  }


  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        {!isOpen && (
          <MIconButton onClick={handleOpen}>
            <Icon icon={searchFill} width={20} height={20} />
          </MIconButton>
        )}

        <Slide direction="down" in={isOpen} mountOnEnter unmountOnExit>
          <SearchbarStyle>
            <Input
              autoFocus
              fullWidth
              disableUnderline
              placeholder="Snel zoeken…"
              onChange={(event) => handleChange(event.target.value)}
              value={value}
              startAdornment={
                <InputAdornment position="start">
                  <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                </InputAdornment>
              }
              sx={{ mr: 1, fontWeight: 'fontWeightBold' }}
            />
            <Button variant="contained" onClick={handleClose}
            to={`${PATH_DASHBOARD.employee.students.root}/${result[1]}`}
          component={RouterLink} disabled={result[1] == null}  color={"primary"}>
              {result[0] == null ? '--' : result[0]}
            </Button>
          </SearchbarStyle>
        </Slide>
      </div>
    </ClickAwayListener>
  );
}
